import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { isRelatedCardComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class RelatedCardFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<API.RelatedCardComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, _reservedIds: Array<string>): boolean {
    return isRelatedCardComponent(component);
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
